import {Page} from 'Core/models/Page';
import {DiscrepancySummary} from '../models/AccountDetail';
import {createAction} from 'Shared/utilities/actionCreator';
import {AsyncPage, Empty} from 'Core/models/Async';

export type DiscrepancySummaryFilter = {
  payorName: string;
  paidAmount: string;
  discrepancyAmount: string;
  billAmount: string;
};

const EmptyDiscrepancySummaryFilter: DiscrepancySummaryFilter = {
  payorName: '',
  paidAmount: '',
  discrepancyAmount: '',
  billAmount: '',
};

export enum DiscrepancySummaryActionType {
  GET_DISCREPANCY_SUMMARIES = 'discrepancySummary/GET_DISCREPANCY_SUMMARIES',
  CHANGE_DISCREPANCY_SUMMARIES = 'discrepancySummary/CHANGE_DISCREPANCY_SUMMARIES',
  CHANGE_DISCREPANCY_SUMMARIES_FILTER = 'discrepancySummary/CHANGE_DISCREPANCY_SUMMARIES_FILTER',
}

export const clearDiscrepancySummaries = () =>
  createAction(DiscrepancySummaryActionType.CHANGE_DISCREPANCY_SUMMARIES, DEFAULT_STATE.discrepancySummaries);
export const changeDiscrepancySummariesFilter = (discrepancySummaryFilter: DiscrepancySummaryFilter) =>
  createAction(DiscrepancySummaryActionType.CHANGE_DISCREPANCY_SUMMARIES_FILTER, {discrepancySummaryFilter});
export const getDiscrepancySummaries = (
  encryptedIdentifier: string,
  accountNumber: string,
  sourceId: number,
  paymentDate: Date,
  discrepancySummaryFilter: DiscrepancySummaryFilter,
  page?: Page<DiscrepancySummary>
) =>
  createAction(DiscrepancySummaryActionType.GET_DISCREPANCY_SUMMARIES, {
    encryptedIdentifier,
    accountNumber,
    sourceId,
    paymentDate,
    discrepancySummaryFilter,
    page,
  });

export const changeDiscrepancySummaries = (discrepancySummaries: AsyncPage<Page<DiscrepancySummary>>) =>
  createAction(DiscrepancySummaryActionType.CHANGE_DISCREPANCY_SUMMARIES, discrepancySummaries);

type DiscrepancySummaryState = {
  discrepancySummaries: AsyncPage<Page<DiscrepancySummary>>;
  discrepancySummaryFilter: DiscrepancySummaryFilter;
};

export const DEFAULT_STATE: DiscrepancySummaryState = {
  discrepancySummaries: new Empty(),
  discrepancySummaryFilter: EmptyDiscrepancySummaryFilter,
};

type DiscrepancySummaryAction =
  | ReturnType<typeof getDiscrepancySummaries>
  | ReturnType<typeof changeDiscrepancySummariesFilter>
  | ReturnType<typeof changeDiscrepancySummaries>;

export default (
  state: DiscrepancySummaryState = DEFAULT_STATE,
  action: DiscrepancySummaryAction
): DiscrepancySummaryState => {
  switch (action.type) {
    case DiscrepancySummaryActionType.CHANGE_DISCREPANCY_SUMMARIES_FILTER:
      const {discrepancySummaryFilter} = action.payload;
      return {
        ...state,
        discrepancySummaryFilter,
      };
    case DiscrepancySummaryActionType.CHANGE_DISCREPANCY_SUMMARIES:
      return {
        ...state,
        discrepancySummaries: action.payload,
      };
    default:
      return state;
  }
};
